import React from 'react';
import Icon from '../icon';
import { useTranslations } from '@fshr/context/i18n-context';
import Link from '../link';

interface TransportPromptProps {
	type: 'arrival' | 'departure';
	url: string;
	date?: string;
}

export const TransportPrompt: React.FC<TransportPromptProps> = ({ type, url, date }) => {
	const t = useTranslations();
	return (
		<div
			className="flex items-stretch spacing-inline-xs relative"
			role="listitem"
			aria-label={t('Transport Prompt')}
		>
			<div className="flex flex-col h-full">
				{/* Timeline dot and line */}
				<div
					className="absolute left-[3px] top-0 bottom-0 flex flex-col items-center"
					aria-hidden={true}
				>
					{/* Dot */}
					<div className="relative flex h-2 w-2">
						<div className="absolute h-2 w-2 rounded-full bg-[rgb(77,77,77,0.45)]" />
					</div>

					{/* Line */}
					<div className="w-[1px] h-full bg-[rgb(77,77,77,0.45)]" />
				</div>
			</div>

			{/* Content */}
			<div className="flex-1 pl-100 pb-200">
				{/* Date */}
				<div className="text-label text-text-secondary mb-080">{date}</div>
				{/* Card */}
				<div className="rounded bg-surface-raised-subtle p-200 border border-border-subtle">
					<div className="flex flex-col gap-150">
						<h3 className="text-subtitle2 text-text-primary">
							{type === 'arrival'
								? t('May we help you with Arrival transportation?')
								: t('May we help you with Departure transportation?')}
						</h3>
						<Link
							href={url}
							intent="unstyled"
							size="small"
							className="flex items-start gap-100 text-button2 cursor-pointer"
						>
							{t('Request')} <Icon icon="arrow_right" />
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};
